import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import {
  closeEscrowView,
  processEscrowFunds,
  getCompanyFinances,
  payWithBalance
} from '../../../store/actions/paymentsActions';
import { gray } from '../../../style';

const styles = theme => ({
  list: {
    width: 550,
    height: '100%',
    [theme.breakpoints.down('xs')]: {
      width: 350
    }
  },
  gridContainer: {
    padding: '50px'
  },
  title: {
    maxWidth: '300px'
  },
  contentSection: {
    marginTop: '30px'
  },
  icon: {
    color: '#5DBE76',
    marginRight: '20px',
    marginLeft: '100px'
  },
  buttonsContainer: {
    width: '80%',
    margin: '0 auto',
    marginTop: '20px'
  },
  totalContainer: {
    marginTop: '50px',
    marginBottom: '30px',
    textAlign: 'center'
  },
  secureText: {
    marginBottom: '10px'
  },
  spinnerContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyItems: 'center',
    background: 'white',
    zIndex: '1000',
    opacity: '.5'
  },
  downArrow: {
    display: 'block',
    margin: '0 auto'
  },
  balanceButton: {
    color: 'white'
  },
  orText: {
    marginTop: '30px'
  },
  balanceMessageContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '30px'
  }
});

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    open: state.payments.escrowViewOpen,
    deal: state.payments.deal,
    errorMessage: state.payments.escrowFailureMessage,
    paymentIsProcessing: state.payments.paymentIsProcessing,
    finances: state.finances
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    closeClick: () => dispatch(closeEscrowView()),
    handleprocessEscrowFunds: (paymentDetails, dealId) =>
      dispatch(processEscrowFunds(paymentDetails, dealId)),
    getCompanyFinances: onComplete =>
      dispatch(getCompanyFinances()).then(() => {
        onComplete();
      }),
    payWithBalance: (dealId, onComplete) =>
      dispatch(payWithBalance(dealId)).then(() => {
        onComplete();
      })
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withProps(({ auth }) => ({
    auth
  })),
  withRouter,
  withStyles(styles)
);



// WEBPACK FOOTER //
// ./src/components/deals/escrow-funds/EscrowFunds.enhancer.js